import { SuggestedOutlineEditsResult } from '../types';
import API from './api';

interface OutlineOptions {
  instruction?: string;
  fileIds?: string[]; // File service file ids
}

interface SlideDescriptionRecommendation {
  description: string;
  reasonForRecommendation: string;
}

export const suggestSlideOutline = async (projectId: string, options: OutlineOptions) => {
  const response = await API().post(`/projects/${projectId}/suggest-outline`, options);
  return response.data;
};

export const suggestSlideOutlineEdits = async (projectId: string, instruction: string, fileIds?: string[]) => {
  const response = await API().post(`/projects/${projectId}/suggest-outline-edits`, { instruction, fileIds });
  return response.data as SuggestedOutlineEditsResult;
};

export const generateSlideData = async (projectId: string, slideIndex: number, instruction?: string, fileIds?: string[]) => {
  const response = await API().post(`/projects/${projectId}/generate-slide-data`, { 
    slideIndex,
    instruction,
    fileIds,
  });
  return response.data;
}

export const generateJsonSchema = async (templateId: string, instruction: string) => {
  const response = await API().post(`/templates/${templateId}/generate-json-schema`, { instruction });
  return response.data;
}

export const suggestTemplateSlideNumber = async (projectId: string, slideIndex: number): Promise<{slideNumber: number, reason?: string}> => {
  const response = await API().post(`/projects/${projectId}/suggest-template-slide-number`, { slideIndex });
  return response.data;
}

export const suggestTemplateSlideNumbers = async (projectId: string, slideIndexes: number[]): Promise<number[]> => {
  const response = await API().post(`/projects/${projectId}/suggest-template-slide-numbers`, { slideIndexes });
  return response.data;
}

export const suggestSlideElementValue = async (
  projectId: string,
  slideIndex: number,
  elementName: string,
  elementType: 'text' | 'picture' | 'table' | 'chart',
  instruction?: string,
  fileIds?: string[]
): Promise<string> => {
  const response = await API().post(`/projects/${projectId}/slides/${slideIndex}/suggest-slide-element-value`, {
    elementName,
    elementType,
    instruction,
    fileIds,
  });
  return response.data.value;
};

export const recommendSlideDescription = async (
  projectId: string, 
  slideIndex: number
): Promise<SlideDescriptionRecommendation> => {
  const response = await API().post(`/projects/${projectId}/recommend-slide-description`, { slideIndex });
  return response.data;
};

export const batchRecommendSlideDescriptions = async (
  projectId: string,
  slideIndices?: number[]
): Promise<Array<{ index: number; recommendation: SlideDescriptionRecommendation }>> => {
  const response = await API().post(`/projects/${projectId}/batch-recommend-slide-descriptions`, { slideIndices });
  return response.data;
};
